import { useEffect } from 'react';
import Helmet from 'react-helmet';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom'
import NotFound from './pages/404';
import About from './pages/about';
import Consulting from './pages/consulting';
import Contact from './pages/contact';
import Services from './pages/services';
import Careers from './pages/careers';
import PrivacyPolicy from './pages/Privacy Policy/Privacypolicy';


function Tekstrive() {
  return (
    <>
      <Helmet>
        <title>TekStrive - It consulting and Services</title>    
        <meta
          name="description"
          content="The best IT Consulting and Service company you can find"
        />
      </Helmet>
      <div className="stact-container">
        <Router>
          <ScrollToTop/>
            <Routes>
              <Route path='/' element={<Consulting/>} />
              <Route path='/about' element={<About/>} />
              <Route path='/careers' element={<Careers/>} />
              <Route path='/contact' element={<Contact/>} />
              <Route path='/services' element={<Services/>} />
              <Route path='/PrivacyPolicy' element={<PrivacyPolicy/>} />
              <Route path='*' element={<NotFound/>} />
            </Routes>
        </Router>
      </div>
    </>
  );
}

const ScrollToTop = () => {
  const {pathname} = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null
}

export default Tekstrive;
